import React from 'react'
import { useRef, useState, useLayoutEffect, clientHeight } from "react";
import { Tab } from 'react-tabs'
import PropTypes from 'prop-types'
import EditListModalLink from './Features/EditList/EditListModalLink'

const WishlistsTab = ({ 
    Name,
    Items,
    IsActive, 
    ToggleEditListModal,
    Last
}) => {

    const quantityDisplay = () => {
        let quantity = 0;
        Items.forEach(element => {
            quantity += element.Quantity;
        });
        return `${quantity} ${quantity === 1 ? "item" : "items"}`;
    }

    const [height, setHeight] = useState(0);

    useLayoutEffect(() => {
        let createList = document.querySelector('.create-list');
        setHeight(createList.clientHeight);
    }, []);
    
    return (
        <Tab className={IsActive ? "list-option active" : "list-option"} style={Last ? ({ marginBottom: height }) : {}}>
            <h4 className={`headline headline-sm wishlist-name ${Last}`} >{Name} ({quantityDisplay()})</h4>
            <EditListModalLink
                AdditionalClasses="btn-edit"
                Size='sm'
                ToggleEditListModal={ToggleEditListModal}
                Name={Name} />
        </Tab>
    );
};

WishlistsTab.propType = {
    Name: PropTypes.string.isRequired,
    Items: PropTypes.array.isRequired,
    IsActive: PropTypes.bool,
    ToggleEditListModal: PropTypes.func,
    length: PropTypes.bool
};

export default WishlistsTab;
